export default {
  schedules: {
    type: Array,
    required: true
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/active-agenda/components/present/resources/props.js